// extracted by mini-css-extract-plugin
module.exports = {"facebook-bg":"social-facebook-bg_6c53d565","vk-bg":"social-vk-bg_1b7babad","steam-bg":"social-steam-bg_40e3b8ca"};